import { useEffect } from 'react';

import type { AgentForm } from '../../../utilities';
import { CUSTOM_URL_VALUE } from '../../../components/AgentForm/const';

type UseBackgroundAudioSettingsProps = {
  form: AgentForm | null;
  setForm: React.Dispatch<React.SetStateAction<AgentForm | null>>;
  setFormId: React.Dispatch<React.SetStateAction<number>>;
};

export const useBackgroundAudioSettings = ({
  form,
  setForm,
  setFormId,
}: UseBackgroundAudioSettingsProps) => {
  useEffect(() => {
    if (!form) return;

    const isEnabled = form.background_audio_enabled;

    if (!isEnabled) {
      setForm((f: AgentForm | null) => {
        if (!f) return f;

        return {
          ...f,
          background_audio_ambient_sound: null,
          background_audio_ambient_custom_url: null,
          background_audio_ambient_volume: 0.3,
          background_audio_thinking_sound: null,
          background_audio_thinking_custom_url: null,
          background_audio_thinking_volume: 0.5,
        };
      });
      setFormId(f => f + 1);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form?.background_audio_enabled]);

  useEffect(() => {
    if (!form) return;

    const ambientSound = form.background_audio_ambient_sound;
    const thinkingSound = form.background_audio_thinking_sound;
    const ambientCustomUrl = form.background_audio_ambient_custom_url;
    const thinkingCustomUrl = form.background_audio_thinking_custom_url;

    const shouldClearAmbientCustom =
      ambientSound !== CUSTOM_URL_VALUE && !!ambientCustomUrl;
    const shouldClearThinkingCustom =
      thinkingSound !== CUSTOM_URL_VALUE && !!thinkingCustomUrl;
    if (!shouldClearAmbientCustom && !shouldClearThinkingCustom) return;

    setForm((f: AgentForm | null) => {
      if (!f) return f;

      return {
        ...f,
        background_audio_ambient_custom_url: shouldClearAmbientCustom
          ? null
          : f.background_audio_ambient_custom_url,
        background_audio_thinking_custom_url: shouldClearThinkingCustom
          ? null
          : f.background_audio_thinking_custom_url,
      };
    });
    setFormId(f => f + 1);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    form?.background_audio_ambient_sound,
    form?.background_audio_thinking_sound,
    form?.background_audio_ambient_custom_url,
    form?.background_audio_thinking_custom_url,
  ]);
};
